/* src/app/pages/small-molecule/graph/graph.component.scss */
.chartCards {
  background-color: lightgoldenrodyellow;
}
/*# sourceMappingURL=graph.component.css.map */
